// all name is CamelCase
const authentication = {
  Login: 'user/login',
  LoginByCode: 'user/login-by-code',
  verifyCode: 'user/add-verify-code',
}
export default authentication
